import { getToken } from 'adalConfig'
import type { AxiosError } from 'axios'
import axios from 'axios'
import config from 'config'
import { METHODS } from 'constants.js'
import { logger, parseDateForRequest } from 'utils'

export function getErrorTranslationKey(errorCode?: number | null) {
  switch (errorCode) {
    case 401:
    case 404:
    case 500:
      return errorCode

    default:
      return 'dataFailedToRetrieve'
  }
}

const getNetworkErrorEvent = (error: any) => {
  const unknownError = 'unknown network error'
  if (!error || !error.response) {
    return unknownError
  }

  const message = `${error.response.status} ${error.response.statusText}`
  return message.trim().length > 0 ? message : unknownError
}

const getNetworkErrorDetails = (error: any) => {
  if (!error || !error.response || !error.response.data) {
    return 'probably 500'
  }

  return `errors:\n${JSON.stringify(error.response.data)}`
}

function validateMethod(method?: METHODS) {
  return method && [METHODS.GET, METHODS.PATCH, METHODS.POST].includes(method) ? method : METHODS.GET
}

export const fetchAction = async (url: string, fetchParams: any, method?: METHODS, signal?: AbortSignal) => {
  const request = axios[validateMethod(method)]

  try {
    const { dateCompared, ...baseParams } = fetchParams
    const params = {
      ...baseParams,
      ...(baseParams.dateCurrent && { dateCurrent: parseDateForRequest(baseParams.dateCurrent, true) }),
      ...(dateCompared && { dateCompared: parseDateForRequest(dateCompared) }),
    }

    if (process.env.STORYBOOK_DEV) {
      const { default: getData } = await import('../../mock-data/data')
      const allData: any = getData()
      const dataKey = url.replace(config.api.url || '', '').replace(/^\//, '')
      const data = allData?.[dataKey]

      if (data) return { data }
    }

    if (method === METHODS.PATCH || method === METHODS.POST) {
      return axios[method](url, params, {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'Content-Type': 'application/json',
        },
        signal,
      })
    }

    return await request(url, {
      params,
      signal,
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
  } catch (error) {
    logger.error(getNetworkErrorEvent(error), `${method}: ${url}`, getNetworkErrorDetails(error))
    throw error
  }
}

export type NetworkError = AxiosError
